'use client'

import { RefObject, createContext } from 'react'

import { UiState } from '@marketplace-web/shared/ui-helpers'

import { CURRENCY_FALLBACK, LOCALE_FALLBACK } from '../constants'
import { CatalogAction } from './reducers/actionTypes'
import {
  CatalogBrandState,
  CatalogState,
  ConfigurationState,
  DataState,
  DtoState,
  DynamicFiltersState,
  FilterState,
  GeneralState,
  SearchSessionState,
} from './types'

export const initialFilterState: FilterState = {
  catalogIds: [],
  priceFrom: null,
  priceTo: null,
  currency: null,
  sortBy: null,
  isPopularCatalog: false,
  isPersonalizationDisabled: false,
  catalogFrom: null,
  disableSearchSaving: false,
}

export const initialDynamicFilterState: DynamicFiltersState = {
  dynamicFilters: [],
  selectedDynamicFilters: [],
  temporarySelectedDynamicFilters: [],
  temporaryCatalogIds: [],
  filterFacetsCount: null,
  filterFacetsCountMax: null,
  temporaryPriceRange: {
    priceFrom: null,
    priceTo: null,
  },
  filterSearchQuery: {
    text: null,
    code: null,
  },
  ui: {
    uiState: UiState.Idle,
    errors: [],
  },
}

export const initialDtoState: DtoState = {
  catalogs: [],
  dynamicFilters: [],
  selectedDynamicFilters: [],
}

export const initialDataState: DataState = {
  catalogTree: [],
  catalogs: [],
  uiState: UiState.Pending,
}

export const initialConfigurationState: ConfigurationState = {
  config: {
    currency: CURRENCY_FALLBACK,
    locale: LOCALE_FALLBACK,
  },
  ui: {
    uiState: UiState.Idle,
    errors: [],
  },
}

export const initialCatalogBrandState: CatalogBrandState = {
  brand: undefined,
}

export const initialSearchSessionState: SearchSessionState = {
  correlationId: '',
  sessionId: '',
  globalSearchSessionId: null,
  globalCatalogBrowseSessionId: null,
}

export const initialGeneralState: GeneralState = {
  filtersChangeCount: 0,
  title: null,
}

export const initialState: CatalogState = {
  filters: initialFilterState,
  dynamicFilters: initialDynamicFilterState,
  dtos: initialDtoState,
  data: initialDataState,
  configuration: initialConfigurationState,
  catalogBrand: initialCatalogBrandState,
  searchSession: initialSearchSessionState,
  general: initialGeneralState,
}

type CatalogContextType = {
  state: CatalogState
  dispatch: React.Dispatch<CatalogAction>
  refs: CatalogRefs
}

type CatalogRefs = {
  dynamicFilterRequestVersion: RefObject<number> | undefined
}

const CatalogContext = createContext<CatalogContextType>({
  state: initialState,
  dispatch: () => null,
  refs: {
    dynamicFilterRequestVersion: undefined,
  },
})

export default CatalogContext
